
const maxWidth = 1200;
const descFont = 22;

export {
  maxWidth,
  descFont
}